import { useNetworkStatus } from "@/hooks/useNetworkStatus";
import { WifiOff } from "lucide-react";

/**
 * Banner displayed at the top of the screen when the user is offline.
 *
 * Features:
 * - Automatically appears when network connection is lost
 * - Automatically disappears when connection is restored
 * - Sticky positioning ensures it's always visible
 * - High z-index to appear above all other content
 *
 * @example
 * ```tsx
 * // In App.tsx or main layout
 * <OfflineBanner />
 * <YourMainContent />
 * ```
 */
export function OfflineBanner() {
  const isOnline = useNetworkStatus();

  // Don't render anything if online
  if (isOnline) {
    return null;
  }

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 bg-destructive text-destructive-foreground shadow-lg"
      role="alert"
      aria-live="assertive"
    >
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-center gap-2 text-sm font-medium">
          <WifiOff className="h-4 w-4" />
          <span>
            Vous êtes hors ligne. Certaines fonctionnalités sont limitées.
          </span>
        </div>
      </div>
    </div>
  );
}
